export const CONNECTED_CHAIN = 'Arbitrum One'
export const CONNECTED_CHAIN_ID = "arbitrum-one";
export const CONNECTED_CHAIN_EXPLORER = "https://arbiscan.io/";
